/*External dependencies*/
import { gql } from '@apollo/client';

export const approveDeviceMutation = gql`
  mutation ApproveDevice($input: ApproveDeviceInput!) {
    approveDevice(input: $input) {
      ... on Terminal {
        id
        __typename
        address
        approvalsCount
        location {
          lat
          lon
        }
        notes
        organization
        registrationDate
        status
        user {
          id
        }
      }
    }
  }
`;
